module.exports = __webpack_public_path__ + "static/img/head.d3c0d59f.jpg";